import React, { useEffect, useRef, useState } from "react";
import { Tree } from "antd";
import { useSelector } from "react-redux";
import { htmlToJSON } from "../Utility/htmlToJSON";
import { useDispatch } from "react-redux";
import { expandedTree, treeStructure } from "../reducer/slice";
import { edit } from "react-arborist/dist/module/state/edit-slice";

const TreeViewAnt = (props) => {
  const [gData, setGData] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const treeRef = useRef(null);

  const dispatch = useDispatch();

  const editorcontent = useSelector((state) => state.editor.content);

  const selectedNode = useSelector((state) => state.editor.selectedStructure);

  useEffect(() => {
    setExpandedKeys(getAllParentKeys(selectedNode, gData));
    setSelectedKeys([selectedNode?.key]);
    setAutoExpandParent(true);
  }, [selectedNode]);

  useEffect(() => {
    if (treeRef.current) {
      const selectedElement = treeRef.current.querySelector(
        ".ant-tree-treenode-selected"
      );

      if (selectedElement) {
        selectedElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [selectedKeys]);

  // useEffect(() => {
  //   let el = document.querySelector([`key = ${selectedNode?.key}`]);
  //   console.log(el);
  // }, [selectedNode]);

  const getAllParentKeys = (key, nodes, path = []) => {
    // console.log(key, nodes, path);
    if (!nodes) return null; // No nodes to search in

    // Traverse the tree recursively
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      console.log(node);

      if (String(node.key) === String(key?.key)) {
        console.log("Match found!");
        return [...path, node.key];
      }

      if (node.children) {
        const res = getAllParentKeys(key, node.children, [...path, node.key]);
        if (res) return res;
      }
    }

    // If not found, return null
    return null;
  };

  let keySet = new Set();
  let keyCounter = 0;

  function ensureUniqueKeys(tree) {
    return tree.map((node) => {
      let newKey = node.key;

      if (keySet.has(newKey)) {
        newKey = `${newKey}_${keyCounter++}`;
      }

      keySet.add(newKey);

      return {
        ...node,
        key: newKey,
        children: node.children ? ensureUniqueKeys(node.children) : [],
      };
    });
  }

  useEffect(() => {
    if (editorcontent?.getbody?.json) {
      const jsonData = editorcontent.getbody.json;
      const cleanedTree = ensureUniqueKeys(
        Array.isArray(jsonData) ? jsonData : [jsonData]
      );
      setGData(cleanedTree);
      // const newTreeData = Array.isArray(jsonData) ? jsonData : [jsonData];

      // setGData((prevGData) => {
      //   return JSON.stringify(prevGData) !== JSON.stringify(newTreeData)
      //     ? newTreeData
      //     : prevGData;
      // });
    }
  }, [editorcontent]);

  // useEffect(() => {
  //   const storedKeys = JSON.parse(localStorage.getItem("expandedTreeKeys"));
  //   if (storedKeys) {
  //     setExpandedKeys(storedKeys);
  //   }
  // }, []);

  const onDragEnter = (info) => {
    // console.log(info);
    // expandedKeys, set it when controlled is needed
    // setExpandedKeys(info.expandedKeys)
  };

  const onDrop = (info) => {
    const dropKey = info.node.key;
    const dragKey = info.dragNode.key;
    const dropPos = info.node.pos.split("-");
    const dropPosition =
      info.dropPosition - Number(dropPos[dropPos.length - 1]); // the drop position relative to the drop node, inside 0, top -1, bottom 1

    const loop = (data, key, callback) => {
      for (let i = 0; i < data.length; i++) {
        if (data[i].key === key) {
          return callback(data[i], i, data);
        }
        if (data[i].children) {
          loop(data[i].children, key, callback);
        }
      }
    };
    // const data = [...gData];
    const data = JSON.parse(JSON.stringify(gData)); // Ensures mutability

    // Find dragObject
    let dragObj;
    loop(data, dragKey, (item, index, arr) => {
      arr.splice(index, 1);
      dragObj = item;
    });
    if (!info.dropToGap) {
      // Drop on the content
      loop(data, dropKey, (item) => {
        item.children = item.children || [];
        // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
        item.children.unshift(dragObj);
      });
    } else {
      let ar = [];
      let i;
      loop(data, dropKey, (_item, index, arr) => {
        ar = arr;
        i = index;
      });
      if (dropPosition === -1) {
        // Drop on the top of the drop node
        ar.splice(i, 0, dragObj);
      } else {
        // Drop on the bottom of the drop node
        ar.splice(i + 1, 0, dragObj);
      }
    }
    console.log(data);

    dispatch(treeStructure({ data: data }));
    setGData(data);
  };

  // MARK: handleClick function
  const handleClick = (e, node) => {
    const editorbody = props.dom;
    console.log(node);

    // console.log(editorbody);

    console.log(editorbody);
    // // console.log(node);

    if (node && node.key) {
      console.log("here");

      const targetElement = editorbody?.querySelector(`[key="${node.key}"]`);

      console.log(targetElement);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  // const expandedKey = useSelector((state) => state.editor.expandedtree);

  const handleExpand = (keys) => {
    // dispatch(expandedTree(keys));
    // localStorage.setItem("expandedTreeKeys", JSON.stringify(keys));
    setExpandedKeys(keys);
  };

  return (
    <div className="w-full py-4 px-2 relative overflow-auto" ref={treeRef}>
      <Tree
        className="draggable-tree"
        rootStyle={{ width: "15%" }}
        // defaultExpandedKeys={expandedKey}
        expandedKeys={expandedKeys}
        selectedKeys={selectedKeys}
        onExpand={handleExpand}
        draggable
        blockNode
        onDragEnter={onDragEnter}
        onDrop={onDrop}
        onClick={(e, node) => handleClick(e, node)}
        treeData={gData}
      />
    </div>
  );
};
export default TreeViewAnt;
